import { z } from 'zod';

export const confirmTelegramOidcSwitchRequestSchema = z.object({
  pendingToken: z.string().optional(),
});

export type IConfirmTelegramOidcSwitchRequest = z.infer<
  typeof confirmTelegramOidcSwitchRequestSchema
>;
